// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2T72E","modalForm":"UpgradeEpcsModal_modalForm__1PxjG","modalFooter":"UpgradeEpcsModal_modalFooter__sTXKK"};